import React from 'react';

import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';

import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { isMobileDevice } from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';

import { useTranslation } from 'react-i18next';
const ReportProcedureDataFooter = ({
    handleSubmitProcedure,
    handleCancel,
    isDisabled,
}) => {
    const { t } = useTranslation();
    const isMobile = isMobileDevice();
    const isIpadAir = window.innerWidth <= sizes.ipadAir;

    return (
        <>
            <BottomNavigation
                justifyContent={'flex-end'}
                opacity={'1'}
                position={isIpadAir ? 'fixed' : 'absolute'}
                mbPosition={'fixed'}
                buttonsPosition={'fixed'}
                padding={
                    window.innerWidth <= sizes.mobileDevice ? '11px' : '5px'
                }
                mbPadding={'11px'}
                moblieJustifyContent={'space-evenly'}
                smalDeviceJustifyContent={'center'}
                isIPadPotrait={true}
                iPadPortraitFooterPosition={'fixed'}
                iPadPortraitJustifyContent={'center'}
                isReportProcedureDataFooter={true}
            >
                {' '}
                <Button
                id={'orders-orderdetails-reportproceduredatafooter-cancel'}
               
                    show
                    width={isMobile ? '37%' : '20%'}
                    mobileWidth={'45%'}
                    height={'38px'}
                    clicked={(event) => {
                        handleCancel(event);
                    }}
                    margin={isMobile ? '2px 10px 2px 0px' : '4px 10px 4px 10px'}
                    fontSize={'15px'}
                    borderRadius={'25px'}
                    secondary={true}
                    variant={ButtonStyles?.secondary}
                >
                    {t('orders.orderDetails.orderDetailFooter.cancel')}
                </Button>
                <Button
                id={'orders-orderdetails-reportproceduredatafooter-submit'}
                   
                    show
                    width={isMobile ? '37%' : '20%'}
                    mobileWidth={'45%'}
                    height={'38px'}
                    clicked={(event) => {
                        handleSubmitProcedure(event);
                    }}
                    margin={isMobile ? '2px 10px 2px 0px' : '4px 10px 4px 10px'}
                    fontSize={'15px'}
                    borderRadius={'25px'}
                    // primary={!isDisabled}
                    disabled={isDisabled}
                    variant={isDisabled ? ButtonStyles?.disabled : ButtonStyles?.primary}
                >
                    {t('consignment.progressBar.submit')}
                </Button>
            </BottomNavigation>
        </>
    );
};

export default ReportProcedureDataFooter;
